module.exports = __webpack_public_path__ + "static/img/xs2.06ff1d98.png";